import { AfterViewInit, ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProgressBarDetails } from '../api/models/ProgressBarDetails';
import { RouteURLConstants } from '../constants/upplm.constants';
import { ROUTE_MAIN_DATA } from '../constants/upplm.constants.routemain';
import { UpsCommonService } from '../services/upplm.common.service';
import { ProgressBarService } from '../services/upplm.progressbar.service';
import { UpplmServices } from '../services/upplm.service';
import { UpplmSessionService } from '../services/upplm.session.service';
declare var $: any;
const MAIN_ROUTE_UPPLM = '/upplm';

@Component({
    selector: 'main-component',
    template: `

        <div *ngIf="pbDetails.showStatusBar">
	        <div class="row .hidden-md-down">
		        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-3 col-xl-3">
			        <upsProgressBar > </upsProgressBar>
		        </div>			
		        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-9 col-xl-9">
		            <div *ngIf="viewChangeTemplate=='upplm'"><locationdetails></locationdetails></div>   
			        <div *ngIf="viewChangeTemplate=='locationdetails'"><locationdetails></locationdetails></div>
                     <div *ngIf="viewChangeTemplate=='contactdetails'"><contactdetails></contactdetails></div>
                    <div *ngIf="viewChangeTemplate=='placarddetails'"><placarddetails></placarddetails></div>
                    <div *ngIf="viewChangeTemplate=='pickupdetails'"><pickupdetails></pickupdetails></div>
                    <div *ngIf="viewChangeTemplate=='notificationdetails'"><notificationdetails></notificationdetails></div>
		        </div>
	        </div>
        </div>
        <div *ngIf="!pbDetails.showStatusBar">
            <div class="row .hidden-md-down">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-3 col-xl-3"> </div>	
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
		            <div *ngIf="viewChangeTemplate=='upplm'"><locationdetails></locationdetails></div>   
			        <div *ngIf="viewChangeTemplate=='locationdetails'"><locationdetails></locationdetails></div>
                    <div *ngIf="viewChangeTemplate=='placardexists'"><placardexists></placardexists></div>
                    <div *ngIf="viewChangeTemplate=='contactdetails'"><contactdetails></contactdetails></div>
                    <div *ngIf="viewChangeTemplate=='placarddetails'"><placarddetails></placarddetails></div>
                    <div *ngIf="viewChangeTemplate=='pickupdetails'"><pickupdetails></pickupdetails></div>
                    <div *ngIf="viewChangeTemplate=='notificationdetails'"><notificationdetails></notificationdetails></div>
                    <div *ngIf="viewChangeTemplate=='review'"><review></review></div>
                    <div *ngIf="viewChangeTemplate=='confirmation'"><confirmation></confirmation></div>
                    <div *ngIf="viewChangeTemplate=='placardconfirmed'"><placardconfirmed></placardconfirmed></div>
                    <div *ngIf="viewChangeTemplate=='placardpending'"><placardVerification></placardVerification></div>
                    <div *ngIf="viewChangeTemplate=='placardlocation'"><placardlocation></placardlocation></div>
                    <div *ngIf="viewChangeTemplate=='approve'"><approve></approve></div>
                    <div *ngIf="viewChangeTemplate=='approveconfirmed'"><approveconfirmed></approveconfirmed></div>
                    <div *ngIf="viewChangeTemplate=='placardaddclientkey'"><placardaddclientkey></placardaddclientkey></div>
                    <div *ngIf="viewChangeTemplate=='placardAddClientKeyConfirm'"><placardAddClientKeyConfirm></placardAddClientKeyConfirm></div>
                    <div *ngIf="viewChangeTemplate=='dashboard'"><templatedashboard></templatedashboard></div>
                   
                    <div *ngIf="viewChangeTemplate=='placardexistsconfirmation'"><placardexistsconfirmation></placardexistsconfirmation></div>
                </div>
            </div>
        </div>
   `
})

export class UpplmRouteMainComponent implements AfterViewInit {
    private route: string;
    public viewChangeTemplate: string;
    private noCompError: boolean = false;
    public showStatusBar: boolean = false;
    pbDetails: ProgressBarDetails;

    constructor(public _router: Router, public _activatedRoute: ActivatedRoute, private _commonService: UpplmServices,
        private cdr: ChangeDetectorRef, private _sessionService: UpplmSessionService,
        private _commonServiceCommon: UpsCommonService,
        private _pbService: ProgressBarService) {
        this.viewChangeTemplate = '';
        this._commonService.viewChanged.subscribe(viewChangeTemplate => {
            if (viewChangeTemplate !== '') {
                this.viewChangeTemplate = this._commonService.viewchangeValue;
            }
        });
        //execute when come from url
        if (this._router.navigated === false) {
            let valueUrlExternal = this._commonServiceCommon.url.split('?')[0];
            valueUrlExternal = valueUrlExternal.split('/').slice(-1)[0];
            if (valueUrlExternal === 'placardpending') {
                this._router.navigateByUrl(RouteURLConstants.UPPLM_VIEW_PLACARD_VERIFICATION_ROUTE);
                this._router.navigateByUrl(valueUrlExternal + '?' + this._commonServiceCommon.url.split('?')[1]);
                return;
            }
            if (valueUrlExternal === 'approve') {
                this._router.navigateByUrl(RouteURLConstants.UPPLM_VIEW_APPROVE_ROUTE);
                return;
            }
            if (valueUrlExternal === 'dashboard') {
                this._router.navigateByUrl(RouteURLConstants.UPPLM_VIEW_DASHBOARD_ROUTE);
                return;
            }
            if (this._router.url !== '/upplm' && this._router.url !== '/locationdetails') {
                this._pbService.pb = new ProgressBarDetails();
                this._router.navigateByUrl(RouteURLConstants.UPPLM_VIEW_LOCATIONS_DETAILS_ROUTE);
            }
        }
    }

    ngOnInit() {
        this.pbDetails = this._pbService.pb;
    }

    ngAfterViewInit() {
        this.customRoute();
        this.cdr.detectChanges();
    }

    validatePlacardId(placardId: string): boolean {
        if (!(placardId !== null ||
            (typeof placardId !== 'undefined' && placardId))) {
            return false;
        }
        return true;
    }
    validateMainRouteUPPLM(mainRoute: string): boolean {
        if (!(mainRoute !== null ||
            (typeof mainRoute !== 'undefined' && mainRoute) || mainRoute !== MAIN_ROUTE_UPPLM)) {
            return false;
        }
        return true;
    }
    customRoute() {
        this.route = this._router.url.split('?')[0];
        this.route = decodeURI(this.route);

        const placardidParam: string = this._activatedRoute.snapshot.queryParamMap.get('placardid');
        if (this.validatePlacardId(placardidParam) && this.validateMainRouteUPPLM(this._router.url)) {
            let valueRoute = ROUTE_MAIN_DATA.find(x => x.route === this.route);
            this._pbService.pb.showStatusBar = valueRoute.showStatusBar;
            this.viewChangeTemplate = valueRoute.viewChangeTemplate;
            this._commonService.viewchangeValue = valueRoute.viewchangeValue;
        }
        else {
            let valueUrlExternal = this._commonServiceCommon.url.split('?')[0];
            valueUrlExternal = valueUrlExternal.split('/').slice(-1)[0];

            //url external
            if (valueUrlExternal === 'placardconfirmed'
                || valueUrlExternal === 'placardpending'
                || valueUrlExternal === 'placardlocation'
                || valueUrlExternal === 'approve'
                || valueUrlExternal === 'dashboard'           
                || valueUrlExternal === 'approveconfirmed') {
                this.display(valueUrlExternal);
            }
            else {
                //url internal
                switch (this.route) {
                    case '/locationcreated':
                        this.viewChangeTemplate = "confirmation";
                        this._commonService.viewchangeValue = "confirmation";
                        break;
                    case '/locationpending':
                        this.viewChangeTemplate = "review";
                        this._commonService.viewchangeValue = "review";
                        break;
                    case '/notificationdetails':
                        this.viewChangeTemplate = "notificationdetails";
                        this._commonService.viewchangeValue = "notificationdetails";
                        break;
                    case '/pickupdetails':
                        this.viewChangeTemplate = "pickupdetails";
                        this._commonService.viewchangeValue = "pickupdetails";
                        break;
                    case '/placarddetails':
                        this.viewChangeTemplate = "placarddetails";
                        this._commonService.viewchangeValue = "placarddetails";
                        break;
                    case '/contactdetails':
                        this.viewChangeTemplate = "contactdetails";
                        this._commonService.viewchangeValue = "contactdetails";
                        break;
                    case '/placardexists':
                        this.viewChangeTemplate = "placardexists";
                        this._commonService.viewchangeValue = "placardexists";
                        break;
                    case '/placardlocation':
                        this._pbService.pb.showStatusBar = false;
                        this.viewChangeTemplate = "placardlocation";
                        this._commonService.viewchangeValue = "placardlocation";
                        break;
                    case '/locationdetails':
                        this.viewChangeTemplate = "locationdetails";
                        this._commonService.viewchangeValue = "locationdetails";
                        break;
                    case '/dashboard':
                        this.viewChangeTemplate = "dashboard";
                        this._commonService.viewchangeValue = "dashboard";
                        break;
                    case '/placardaddclientkey':
                        this.viewChangeTemplate = "placardaddclientkey";
                        this._commonService.viewchangeValue = "placardaddclientkey";
                        break;
                    case '/placardAddClientKeyConfirm':
                        this.viewChangeTemplate = "placardAddClientKeyConfirm";
                        this._commonService.viewchangeValue = "placardAddClientKeyConfirm";
                        break;
                    case '/upplm':
                        this.viewChangeTemplate = "locationdetails";
                        this._commonService.viewchangeValue = "locationdetails";;
                        break;
                    case '/approveconfirmed':
                        this._pbService.pb.showStatusBar = false;
                        this.viewChangeTemplate = "approveconfirmed";
                        this._commonService.viewchangeValue = "approveconfirmed";
                        break;
                    case '/placardexistsconfirmation':
                        this.viewChangeTemplate = "placardexistsconfirmation";
                        this._commonService.viewchangeValue = "placardexistsconfirmation";
                        break;
                    default:
                        this.viewChangeTemplate = "locationdetails";
                        this._commonService.viewchangeValue = "locationdetails";
                }
            }
        }

    }

    display(page: string) {
        this._pbService.pb.showStatusBar = false;
        this.viewChangeTemplate = page;
        this._commonService.viewchangeValue = page;
    }
}